import React from "react";

export const CryptoAllIcon = ( props: React.SVGProps<SVGSVGElement> ) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <path
            d="M6 2H2.66667C2.29848 2 2 2.29848 2 2.66667V6C2 6.3682 2.29848 6.66667 2.66667 6.66667H6C6.3682 6.66667 6.66667 6.3682 6.66667 6V2.66667C6.66667 2.29848 6.3682 2 6 2Z"
            stroke="#18181B"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path
            d="M6 9.33203H2.66667C2.29848 9.33203 2 9.6305 2 9.9987V13.332C2 13.7002 2.29848 13.9987 2.66667 13.9987H6C6.3682 13.9987 6.66667 13.7002 6.66667 13.332V9.9987C6.66667 9.6305 6.3682 9.33203 6 9.33203Z"
            stroke="#18181B"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path
            d="M13.3335 2H10.0002C9.63196 2 9.3335 2.29848 9.3335 2.66667V6C9.3335 6.3682 9.63196 6.66667 10.0002 6.66667H13.3335C13.7017 6.66667 14.0002 6.3682 14.0002 6V2.66667C14.0002 2.29848 13.7017 2 13.3335 2Z"
            stroke="#18181B"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path
            d="M13.3335 9.33203H10.0002C9.63196 9.33203 9.3335 9.6305 9.3335 9.9987V13.332C9.3335 13.7002 9.63196 13.9987 10.0002 13.9987H13.3335C13.7017 13.9987 14.0002 13.7002 14.0002 13.332V9.9987C14.0002 9.6305 13.7017 9.33203 13.3335 9.33203Z"
            stroke="#18181B"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
    </svg>
);
